import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const ClientItem = ({ p, dup }) => (
  <li className="shrink-0 pr-4 md:pr-5" aria-hidden={dup || undefined}>
    <Link to={`/layihe/${p.slug}`} tabIndex={dup ? -1 : undefined} data-testid={dup ? undefined : `client-strip-${p.slug}`}
      className="block w-[190px] md:w-[230px] h-[78px] md:h-[92px] rounded-xl overflow-hidden border border-[#171715]/[0.07] bg-white grayscale-[35%] opacity-85 hover:grayscale-0 hover:opacity-100 hover:-translate-y-0.5 transition-[filter,opacity,transform] duration-300">
      {p.client_logo
        ? <img src={p.client_logo} alt={p.title} className="w-full h-full object-contain p-1" loading="lazy" />
        : <span className="w-full h-full flex items-center justify-center font-display font-semibold text-lg text-[#171715]/70 px-3 text-center">{p.title}</span>}
    </Link>
  </li>
);

export default function ClientStrip() {
  const { projects } = useSite();
  const clients = projects
    .filter((p) => !p.is_concept && p.show_in_clients !== false)
    .sort((a, b) => (a.client_order || 1e9) - (b.client_order || 1e9) || (a.order - b.order) || String(b.created_at).localeCompare(String(a.created_at)));
  if (!clients.length) return null;
  const reps = Math.max(2, Math.ceil(10 / clients.length) * 2);
  const loop = Array.from({ length: reps }, (_, i) => clients.map((p) => ({ p, dup: i > 0, k: `${i}-${p.id}` }))).flat();
  return (
    <section data-testid="client-strip" className="border-y border-[#171715]/[0.07] bg-white/40">
      <div className="container-lm pt-8">
        <p className="eyebrow">Bizə etibar edənlər</p>
      </div>
      <div className="marquee py-7" style={{ "--dur": `${clients.length * reps * 3.5}s` }}>
        <ul className="marquee-track flex w-max">
          {loop.map(({ p, dup, k }) => <ClientItem key={k} p={p} dup={dup} />)}
        </ul>
      </div>
    </section>
  );
}
